import { render, staticRenderFns } from "./FolderCreate.vue?vue&type=template&id=6817dc52"
import script from "./FolderCreate.vue?vue&type=script&lang=ts"
export * from "./FolderCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports